/**
 * taxonomyLabels — display-only EN mapping for backend taxonomy values
 * (redesign item 0: English-only UI). Single source of truth; this file
 * becomes the seed of the full i18n layer later.
 * Fallback = raw value: unmapped keys render as-is, never blank.
 */
const TAXONOMY_LABELS = {
  // Reports taxonomy (Italian → English)
  "Istituzioni globali": "Global Institutions",
  "Istituzioni globali e policy": "Global Institutions & Policy",
  "Accademia e osservatori": "Academia & Observatories",
  "Accademia": "Academia",
  "OTA e marketplace": "OTAs & Marketplaces",
  "Travel tech e infrastrutture": "Travel Tech & Infrastructure",
  "Travel tech / accademia": "Travel Tech / Academia",
  "Travel tech": "Travel Tech",
  "Consulenza e advisory": "Consulting & Advisory",
  "Consulenza": "Consulting",
  "Associazioni e DMO": "Associations & DMOs",
  "NTO e DMO": "NTOs & DMOs",
  "NTO e enti turismo": "NTOs & Tourism Boards",
  "Data e payments": "Data & Payments",
  "Data intelligence e forecasting": "Data Intelligence & Forecasting",
  "Research, media e analisti": "Research, Media & Analysts",
  "Altro": "Other",
  // Article categories (Italian)
  "Agenti di viaggi": "Travel Agents",
  "Attualità": "News",
  "Destinazioni": "Destinations",
  "Tecnologia": "Technology",
  "Ospitalità": "Hospitality",
  "Analisi": "Analysis",
  "Fisco": "Tax & Fiscal",
  "Lusso": "Luxury",
  "Operatori": "Tour Operators",
  "Italia": "Italy",
  "Volare": "Aviation",
  // Article categories (French)
  "Aérien": "Aviation",
  "Croisières": "Cruises",
  "Hébergement": "Accommodation",
  "Hôtellerie": "Hotels",
  "Evénements": "Events",
  "Développement": "Development",
  "E-tourisme": "E-tourism",
  "Enquête": "Investigation",
  "Gestion Opérationnelle": "Operations",
  "Ressources Humaines": "Human Resources",
  "Investisseurs": "Investors",
};

export const labelFor = (raw) => TAXONOMY_LABELS[(raw || "").trim()] || raw;

// Client-side display grouping for the "+ All filters" panel (redesign item 4).
const GROUP_RULES = [
  ["Tech & Innovation", /(^|\b)(ai\b|artificial|tech|technolog|innovation|automation|5g|digital|e-tourisme|startup)/i],
  ["Hospitality & Operators", /(hotel|hospitality|hébergement|hôtellerie|resort|tour operator|operatori|travel agents?|agenti|luxury|lusso|restaurant|ota\b)/i],
  ["Aviation & Transport", /(aviation|airline|airport|cruise|croisi|rail|transport|volare|aérien)/i],
  ["Markets & Destinations", /(destination|destinazioni|italy|italia|italian|spanish|spain|market|europe|region|dmo\b)/i],
  ["Business & Data", /(data|analytics|invest|funding|m&a|merger|payment|revenue|tax|fisco|business|forecast)/i],
];
export const GROUP_ORDER = [
  "Tech & Innovation",
  "Hospitality & Operators",
  "Aviation & Transport",
  "Markets & Destinations",
  "Business & Data",
  "Other topics",
];
export function categoryGroup(cat) {
  for (const [g, re] of GROUP_RULES) if (re.test(cat)) return g;
  return "Other topics";
}
